import { useState } from "react";
import useInterval from "use-interval";
import PropTypes from "prop-types";
import classNames from "classnames";
import { isCMSImage } from "../../utils/CmsUtils";
import "./style.scss";

function SimpleSlideshow({
  images = [],
  delay = 2000,
  playing = false,
  rewindOnPause = false,
  className = "",
  children
}) {
  const [curIndex, setCurIndex] = useState(0);

  useInterval(
    () => {
      if (playing) {
        setCurIndex(curIndex => (curIndex + 1) % images.length);
      } else {
        if (rewindOnPause) setCurIndex(0);
      }
    },
    delay > 0 ? delay : false
  );

  function makeURL(url) {
    if (isCMSImage(url)) {
      return url.styles.preview;
    }
    return url;
  }

  return (
    <div className="simpleSlideshow">
      {images.map((image, idx) => {
        const imageUrl = makeURL(image);
        const imageClasses = classNames(className, "simpleSlideshow-image", {
          "simpleSlideshow-show": curIndex === idx
        });
        const backgroundImage = `url(${imageUrl})`;
        return (
          <div
            key={imageUrl}
            className={imageClasses}
            style={{ backgroundImage }}
          />
        );
      })}
      {children}
    </div>
  );
}

SimpleSlideshow.propTypes = {
  images: PropTypes.array.isRequired,
  delay: PropTypes.number,
  rewindOnPause: PropTypes.bool
};

export default SimpleSlideshow;
